import { TutorialScrollLockDirective } from '../../../../shared/directives/tutorial-scroll-lock.directive';
import { ChangeDetectorRef, Component, ComponentRef, ElementRef, HostListener, Input, NgZone, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  catchError,
  combineLatest,
  concatMap,
  finalize,
  from,
  map,
  of,
  skip,
  Subject,
  switchMap,
  take,
  takeUntil,
  tap,
} from 'rxjs';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatBadgeModule } from '@angular/material/badge';
import { FacilitiesService } from '../../../../core/services/facilities.service';
import { RequestsService } from '../../../../core/services/utils/requests.service';
import { SensorService } from '../../../../core/services/sensors.service';
import { IUnit } from '../../../../shared/models/be/unit';
import { IRoom } from '../../../../shared/models/be/room';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import type { TutorialAlertAction, TutorialAlertDialogComponent } from '../../../../shared/components/tutorial-alert-dialog/tutorial-alert-dialog.component';
import { RoomDetailsDialogComponent } from '../../../../shared/components/roomDetailsDialog/room-details-dialog.component';
import { IDevice } from '../../../../shared/models/be/device';
import { AlertsService } from '../../../../core/services/alerts.service';
import { IonContent, IonLabel, IonSegment, IonSegmentButton, IonButton, AlertController } from '@ionic/angular/standalone';
import { eventTypeToData, EventTypeCodes, INotificationData } from '../../../../shared/models/be/notification';
import { getTimeLeft } from '../../../../shared/utils/transformation.util';
import { RingtoneService } from '../../../../core/services/utils/ringtone.service';
import { SharedService } from '../../../../core/services/shared.service';
import { LoggerService } from '../../../../core/services/utils/logger.service';
import { IBed } from '../../../../shared/models/be/bed';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NotificationService } from '../../../../core/services/notification.service';
import { NetworkStatusService } from '../../../../core/services/network-status.service';
import { StreamingComponent } from '../../../../shared/components/streaming/streaming.component';
import { SpatialTrackingComponent } from '../../spatial-tracking/spatial-tracking.component';
import { SpatialService } from '../../../../core/services/spatial.service';
import { SpatialAvailability, SpatialScope } from '../../../../shared/models/be/spatial';
import { Subscription } from 'rxjs';

import { GuideService } from '../../../../core/services/guide.service';
import { positionTutorialCard, TutorialCardPosition } from '../../../../shared/utils/tutorial-card-position.util';
import { BedStatesSessionComponent } from '../../../../shared/components/bed-states/bed-states-session.component';
import { BedStatesRoomComponent } from '../../../../shared/components/bed-states/bed-states-room.component';
type MonitoringSegment = 'structure' | 'allerts' | 'multi';
interface MentorageTutorialSpotlight {
  top: number;
  left: number;
  width: number;
  height: number;
  borderRadius: number;
}


type MentorageTutorialStep = 'OVERVIEW' | 'STRUCTURE' | 'ROOM' | 'ALERTS' | 'TYPES' | 'MULTI' | 'EXAMPLE_ALERT'
  | 'ALERT_STREAM' | 'ALERT_MANAGE' | 'ALERT_CLOSE' | 'ALERT_COMPLETE';
@Component({
  selector: 'monitoring',
  templateUrl: './monitoring.mobile.component.html',
  styleUrls: ['./monitoring.mobile.component.scss'],
  imports: [TutorialScrollLockDirective,
    CommonModule,
    MatGridListModule,
    MatIconModule,
    TranslateModule,
    RouterModule,
    MatGridListModule,
    MatToolbarModule,
    MatTabsModule,
    MatExpansionModule,
    MatBadgeModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    IonContent,
    IonSegment,
    IonLabel,
    IonSegmentButton,
    IonButton,
    StreamingComponent,
    SpatialTrackingComponent,
    BedStatesSessionComponent,
    BedStatesRoomComponent
  ]
})
export class monitoringMobilePage implements OnInit {

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public facilitiesService: FacilitiesService,
    private requestsService: RequestsService,
    public dialog: MatDialog,
    private sensorService: SensorService,
    private alertService: AlertsService,
    private alertController: AlertController,
    private ringtoneService: RingtoneService,
    public sharedSrv: SharedService,
    private loggerService: LoggerService,
    private cdRef: ChangeDetectorRef,
    private zone: NgZone,
    private notificationService: NotificationService,
    private networkStatusService: NetworkStatusService,
    private spatialService: SpatialService,
    private guide: GuideService,
    private overlay: Overlay
  ) {
    this.visibilityChangeHandler = () => {
      if (document.visibilityState === 'visible') {
        this.reloadMonitoringData(!this.unitsTree.length);
        this.notificationService.checkLocalNotifications();
      }
    };
  }

  ionViewDidEnter() {
  }

  private destroy$ = new Subject<void>();
  public installPrompt?: any;
  public unitsTree: (IUnit & { isOpen: boolean })[] = [];
  public spatialUnits: IUnit[] = [];
  public spatialAvailability: SpatialAvailability | null = null;
  public spatialAvailabilityError = '';
  public structureView: 'cards' | 'map' = 'map';
  public spatialScope: SpatialScope | null = null;
  private spatialAvailabilitySubscription?: Subscription;
  private spatialBuildingId: string | null = null;
  public alertsList: INotificationData[] = [];
  public manageAllRunning: boolean = false;
  public currentSegment: MonitoringSegment = 'structure';
  public eventTypeToData = eventTypeToData;
  public isDataLoading: boolean = false;
  public availableStreamingDevices: IDevice[] = [];
  public selectedDeviceLabels: string[] = [];
  public selectedStreamingDevices: IDevice[] = [];
  public readonly maxMultiViewDevices = 4;
  private visibilityChangeHandler: () => void;
  private isMonitoringDataLoading = false;
  private silencedRefreshScheduled = false;
  private silencedRefreshTimeoutId?: ReturnType<typeof setTimeout>;
  private silencedRefreshIntervalId?: ReturnType<typeof setInterval>;
  private mentorageSpotlightUpdateTimeoutId?: ReturnType<typeof setTimeout>;
  private mentorageScrollFrame?: number;
  private readonly mentorageScrollHandler = () => {
    if (!this.isDesktop || !this.mentorageTutorialActive || this.mentorageScrollFrame !== undefined) {
      return;
    }
    this.mentorageScrollFrame = requestAnimationFrame(() => {
      this.mentorageScrollFrame = undefined;
      this.zone.run(() => this.updateMentorageSpotlight());
    });
  };
  @Input() isDesktop: boolean = false;
  @ViewChildren('text') textElements!: QueryList<ElementRef<HTMLDivElement>>;
  @ViewChildren('tutorialAlertCardElement', { read: ElementRef }) tutorialAlertCardElements!: QueryList<ElementRef<HTMLElement>>;
  @ViewChild('mentorageTutorialCardElement', { read: ElementRef }) mentorageTutorialCardElement?: ElementRef<HTMLElement>;
  @ViewChild('tutorialExampleRoomElement', { read: ElementRef }) tutorialExampleRoomElement?: ElementRef<HTMLElement>;
  @ViewChild('tutorialExampleDialog') tutorialExampleDialog!: TemplateRef<unknown>;
  @ViewChild('tutorialFallAlertElement', { read: ElementRef }) tutorialFallAlertElement?: ElementRef<HTMLElement>;
  @ViewChild('tutorialSegmentElement', { read: ElementRef }) tutorialSegmentElement?: ElementRef<HTMLElement>;
  @ViewChild('tutorialStructureElement', { read: ElementRef }) tutorialStructureElement?: ElementRef<HTMLElement>;
  @ViewChild('tutorialAlertsElement', { read: ElementRef }) tutorialAlertsElement?: ElementRef<HTMLElement>;
  @ViewChild('tutorialMultiElement', { read: ElementRef }) tutorialMultiElement?: ElementRef<HTMLElement>;

  public mentorageTutorialActive: boolean = false;
  public mentorageTutorialStepIndex: number = 0;
  public mentorageTutorialSpotlight?: MentorageTutorialSpotlight;
  public mentorageTutorialCardPosition?: TutorialCardPosition;
  private guideStepOrder?: number[];
  // Stable indexes allow short guides to reuse the same steps on both devices.
  private readonly mobileMentorageTutorialSteps: MentorageTutorialStep[] = ['OVERVIEW', 'STRUCTURE', 'ROOM', 'ALERTS', 'TYPES', 'MULTI', 'EXAMPLE_ALERT', 'ALERT_STREAM', 'ALERT_MANAGE', 'ALERT_CLOSE', 'ALERT_COMPLETE'];
  private readonly desktopMentorageTutorialSteps = this.mobileMentorageTutorialSteps;
  public readonly tutorialAlertTypes: EventTypeCodes[] = ['01', '05', '03', '06'];
  public tutorialAlertManaged = false;
  public tutorialAlertOpening = false;
  private tutorialAlertOverlayRef?: OverlayRef;
  private tutorialAlertComponentRef?: ComponentRef<TutorialAlertDialogComponent>;

  public get tutorialAlertOverlayOpen(): boolean { return !!this.tutorialAlertOverlayRef; }

  private get tutorialStepOrder(): number[] {
    return this.guideStepOrder ?? (this.isDesktop ? [0, 1, 2, 3, 4, 6, 7, 8, 9, 10, 5] : [0, 1, 2, 3, 4, 6, 7, 8, 9, 10]);
  }

  public get mentorageTutorialSteps(): MentorageTutorialStep[] {
    const steps = this.isDesktop ? this.desktopMentorageTutorialSteps : this.mobileMentorageTutorialSteps;
    return this.tutorialStepOrder.map(index => steps[index]);
  }

  public get mentorageTutorialProgressIndex(): number {
    return this.tutorialStepOrder.indexOf(this.mentorageTutorialStepIndex);
  }

  public get mentorageGuideNavigationOffset(): number {
    return this.guide.activeModule === 'rooms' || this.guide.activeModule === 'alerts' || this.guide.activeModule === 'overview' ? 1 : 0;
  }

  public get showTutorialAlertList(): boolean {
    return this.mentorageTutorialActive && (this.guide.activeModule === 'alerts' || this.mentorageTutorialStepIndex >= 6);
  }

  public get isSpatialTrackingEnabled(): boolean {
    const user = this.requestsService.getCurrentUser();
    return user?.role === 'superuser' && user.customer?.spatialTrackingEnabled === true;
  }
  public get mapUnits(): IUnit[] {
    const ids = this.spatialAvailability?.mapUnitIds || [];
    return ids.flatMap(id => this.spatialUnits.filter(unit => unit.id === id));
  }
  public get canSwitchSpatialView(): boolean {
    return this.isDesktop && this.isSpatialTrackingEnabled && this.spatialAvailability?.spatialTrackingEnabled === true && this.spatialAvailability?.canUseSpatialView === true
      && this.mapUnits.length > 0 && this.requestsService.getCurrentUser()?.building?.id === this.spatialBuildingId;
  }
  public get showSpatialMap(): boolean { return this.canSwitchSpatialView && this.structureView === 'map' && !!this.spatialScope; }
  public get selectedSpatialUnitIndex(): number { return this.mapUnits.findIndex(unit => unit.id === this.spatialScope?.unitId); }
  public get selectedSpatialUnit(): IUnit | undefined { return this.mapUnits[this.selectedSpatialUnitIndex]; }
  public setStructureView(view: 'cards' | 'map'): void {
    this.structureView = view;
    if (view === 'map') this.selectSpatialUnit(this.mapUnits[0]);
  }
  public moveSpatialUnit(direction: -1 | 1): void { this.selectSpatialUnit(this.mapUnits[this.selectedSpatialUnitIndex + direction]); }
  private selectSpatialUnit(unit: IUnit | undefined): void {
    if (!unit?.id || !this.canSwitchSpatialView) return;
    this.spatialScope = { customerId: unit.customerId, buildingId: unit.buildingId, unitId: unit.id };
  }
  public disableSpatialView(message = ''): void {
    this.spatialAvailabilitySubscription?.unsubscribe();
    this.spatialAvailability = null; this.spatialScope = null; this.spatialAvailabilityError = message;
    if (message) this.loggerService.error(message);
    this.cdRef.markForCheck();
  }
  /** Refresh the cached customer flag only from authorized metadata for the current scope. */
  private applySpatialAvailability(availability: SpatialAvailability | null, customerId: number, buildingId: string): void {
    const current = this.requestsService.getCurrentUser();
    if (current?.role !== 'superuser' || current.customer?.id !== customerId || current.building?.id !== buildingId
      || this.spatialBuildingId !== buildingId || (availability && availability.buildingId !== buildingId)) return;
    this.spatialAvailability = availability;
    if (availability && typeof availability.spatialTrackingEnabled === 'boolean'
      && current.customer.spatialTrackingEnabled !== availability.spatialTrackingEnabled) {
      this.requestsService.saveCurrentUser({ ...current, customer: { ...current.customer, spatialTrackingEnabled: availability.spatialTrackingEnabled } });
    }
  }
  public refreshSpatialAvailability(): void {
    this.spatialAvailabilitySubscription?.unsubscribe();
    this.spatialAvailabilityError = '';
    const user = this.requestsService.getCurrentUser();
    if (!this.isDesktop || !this.isSpatialTrackingEnabled || !user?.customer?.id || !this.spatialBuildingId || user.building?.id !== this.spatialBuildingId) {
      this.spatialAvailability = null; this.spatialScope = null; return;
    }
    const buildingId = this.spatialBuildingId, customerId = user.customer.id;
    this.spatialAvailabilitySubscription = this.spatialService.availability(customerId, buildingId).pipe(takeUntil(this.destroy$)).subscribe({
      next: availability => this.zone.run(() => {
        this.cdRef.markForCheck();
        const current = this.requestsService.getCurrentUser();
        if (!this.isSpatialTrackingEnabled || current?.building?.id !== buildingId || current.customer?.id !== customerId) return;
        if (availability.buildingId !== buildingId) {
          this.spatialAvailability = null; this.spatialScope = null;
          this.spatialAvailabilityError = 'La disponibilità Spatial non corrisponde all’edificio selezionato. Aggiorna lo stato.';
          return;
        }
        this.applySpatialAvailability(availability, customerId, buildingId);
        if (!this.canSwitchSpatialView) {
          this.spatialScope = null;
          if (availability.canUseSpatialView && availability.mapUnitIds.length && !this.mapUnits.length) {
            this.spatialAvailabilityError = 'Le unità con mappa non sono presenti nella struttura caricata. Aggiorna la pagina.';
          }
          return;
        }
        if (!this.mapUnits.some(unit => unit.id === this.spatialScope?.unitId)) this.selectSpatialUnit(this.mapUnits[0]);
      }),
      error: () => this.zone.run(() => {
        this.cdRef.markForCheck();
        const current = this.requestsService.getCurrentUser();
        if (current?.building?.id !== buildingId || current.customer?.id !== customerId) return;
        this.spatialAvailability = null; this.spatialScope = null;
        this.spatialAvailabilityError = 'Impossibile verificare le mappe Spatial disponibili. Riprova ad aggiornare lo stato.';
        this.loggerService.error('Errore nel recupero della disponibilità delle mappe Spatial.');
      })
    });
  }
  getTimeLeft(data: Date | string) {
    return getTimeLeft(data)
  }
  @HostListener('window:resize')
  onMentorageTutorialViewportChange(): void {
    if (this.mentorageTutorialActive) {
      this.scheduleMentorageSpotlightUpdate();
    }
  }


  ngOnInit() {
    this.guide.request$.pipe(takeUntil(this.destroy$)).subscribe(module => {
      if (module === 'overview' || module === 'rooms' || module === 'alerts') {
        this.guideStepOrder = module === 'rooms' ? [1, 2] : module === 'alerts' ? [4, 6, 7, 8, 9, 10] : undefined;
        this.startMentorageTutorial();
      } else if (this.mentorageTutorialActive) {
        this.guideStepOrder = undefined;
        this.mentorageTutorialActive = false;
        this.mentorageTutorialSpotlight = undefined;
        this.mentorageTutorialCardPosition = undefined;
        this.disposeTutorialAlert();
      }
    });

    this.sharedSrv.unitsTree$.pipe(takeUntil(this.destroy$)).subscribe((newUnitsTree) => {
      this.unitsTree = newUnitsTree;
      this.refreshMultiViewDevices();
      this.zone.run(() => {
        this.cdRef.detectChanges(); // Forza l'aggiornamento della vista
      });
      if (this.mentorageTutorialActive && this.mentorageTutorialStepIndex === 2) {
        this.scrollTutorialRoomIntoView();
      }
    });
    this.sharedSrv.alertsList$.pipe(takeUntil(this.destroy$)).subscribe((alertsList) => {
      this.alertsList = alertsList;
      this.zone.run(() => {
        // Map rooms are separate objects: synchronize both views before rendering.
        this.updateRoomAlerts();
        this.cdRef.detectChanges(); // Forza l'aggiornamento della vista
      });
    });
    this.loadMonitoringData();
    this.networkStatusService.isOnline$.pipe(
      skip(1),
      takeUntil(this.destroy$)
    ).subscribe((isOnline) => {
      if (isOnline) {
        this.reloadMonitoringData(true);
      }
    });
    document.addEventListener('visibilitychange', this.visibilityChangeHandler);
    if (this.isDesktop) {
      document.addEventListener('scroll', this.mentorageScrollHandler, true);
    }
  }

  onSegmentChange(value: string | number | undefined): void {
    if (value === 'multi' && !this.isDesktop) {
      this.currentSegment = 'structure';
      return;
    }

    if (value === 'structure' || value === 'allerts' || value === 'multi') {
      this.currentSegment = value;
    }
  }

  private reloadMonitoringData(forceFullReload: boolean = false) {
    this.refreshSpatialAvailability();
    if (forceFullReload || !this.unitsTree.length) {
      this.loadMonitoringData();
      return;
    }

    this.refreshActiveAlerts();
  }

  private loadMonitoringData() {
    if (this.isMonitoringDataLoading) {
      return;
    }

    const buildingId = this.requestsService.getCurrentUser()?.building?.id;
    if (!buildingId) {
      this.loggerService.error("Nessun edificio trovato per l'utente corrente");
      this.isDataLoading = false;
      return;
    }

    this.isMonitoringDataLoading = true;
    this.isDataLoading = true;

    combineLatest([
      this.requestsService.currentUser$.pipe(take(1)),
      this.sensorService.getDevices$({ buildingId }).pipe(take(1)),
      this.alertService.getActiveAlertsList$().pipe(take(1))
    ]).pipe(
      take(1),
      switchMap(([user, devicesData, notificationsList]) => {
        this.alertsList = this.sharedSrv.sortByTime(notificationsList);
        this.sharedSrv.alertsList = this.alertsList;

        if (!user?.building?.id) {
          this.loggerService.error("Nessun edificio trovato per l'utente corrente");
          return of(null);
        }

        const devices = devicesData.devices || [];
        return this.facilitiesService.getBuilding$(user.building.id, true).pipe(
          take(1),
          tap((building) => {
            this.spatialUnits = this.buildSpatialUnits(building.units || [], devices);
            this.spatialBuildingId = building.id || user.building!.id;
            this.applySpatialAvailability(building.spatial || null, building.customerId, this.spatialBuildingId);
            if (!this.mapUnits.some(unit => unit.id === this.spatialScope?.unitId)) {
              this.spatialScope = null;
              this.selectSpatialUnit(this.mapUnits[0]);
            }
            this.refreshSpatialAvailability();
            this.unitsTree = this.buildUnitsTree(building.units || [], devices);
            this.unitsTree.length === 1 && (this.unitsTree[0].isOpen = true);
            this.sharedSrv.unitsTree = this.unitsTree;
            this.refreshSilencedSensor();
            this.scheduleFunctionAtSpecificMinutes();
          }),
          map(() => null)
        );
      }),
      catchError((err) => {
        this.loggerService.error('Errore nel caricamento dati Mentorage');
        return of(null);
      }),
      finalize(() => {
        this.isMonitoringDataLoading = false;
        this.isDataLoading = false;
        this.zone.run(() => {
          this.cdRef.detectChanges();
        });
        if (this.mentorageTutorialActive && this.mentorageTutorialStepIndex === 2) {
          this.scrollTutorialRoomIntoView();
        }
      })
    ).subscribe();
  }

  private refreshActiveAlerts() {
    this.alertService.getActiveAlertsList$().pipe(
      take(1),
      catchError((err) => {
        this.loggerService.error('Errore nel refresh delle allerte attive');
        return of([]);
      })
    ).subscribe((alerts) => {
      this.zone.run(() => {
        this.alertsList = this.sharedSrv.sortByTime(alerts);
        this.sharedSrv.alertsList = this.alertsList;
        this.cdRef.detectChanges();
      });
    });
  }

  private buildSpatialUnits(units: IUnit[], devices: IDevice[]): IUnit[] {
    return units.map((unit) => ({
      ...unit,
      rooms: unit.rooms?.map((room) => {
        const roomDevices = devices.filter((device) => device.facilities?.room?.id === room.id);
        const roomAlerts = this.sharedSrv.sortByTime(
          this.alertsList.filter((alert) => roomDevices.some((device) => device.label === alert.deviceId))
        );

        return {
          ...room,
          devices: roomDevices,
          offlineMode: this.getOfflineMode(roomDevices),
          alert: roomAlerts[0] || undefined
        };
      })
    }));
  }

  private buildUnitsTree(units: IUnit[], devices: IDevice[]): (IUnit & { isOpen: boolean })[] {
    return units.reduce((acc, curr) => {
      const currentUnitDevices = devices.filter((device) => device.facilities?.unit?.id === curr.id);

      if (!currentUnitDevices.length) {
        return acc;
      }

      acc.push({
        ...curr,
        isOpen: false,
        rooms: curr.rooms
          ?.filter((room) => currentUnitDevices.map((device) => device.facilities?.room?.id).includes(room.id))
          .map((room) => {
            const currRoomDevices = devices.filter((device) => device.facilities?.room?.id === room.id);
            const currAlerts = this.sharedSrv.sortByTime(
              this.alertsList.filter((alert) => currRoomDevices.some((roomDevice) => roomDevice.label === alert.deviceId))
            );

            return {
              ...room,
              devices: currRoomDevices,
              offlineMode: this.getOfflineMode(currRoomDevices),
              alert: currAlerts[0] || undefined
            };
          })
      });

      return acc;
    }, [] as (IUnit & { isOpen: boolean })[]);
  }

  private updateRoomAlerts() {
    [...this.unitsTree, ...this.spatialUnits].forEach((unit) => {
      unit.rooms?.forEach((room) => {
        const currRoomAlerts = this.sharedSrv.sortByTime(
          this.alertsList.filter((alert) => room.devices?.some((device) => device.label === alert.deviceId))
        );
        room.alert = currRoomAlerts[0] || undefined;
        room.offlineMode = this.getOfflineMode(room.devices || []);
      });
    });

    this.sharedSrv.unitsTree = [...this.unitsTree];
  }

  private getOfflineMode(devices: IDevice[]): IRoom['offlineMode'] {
    if (!devices.some((device) => device.status === 'offline')) {
      return undefined;
    }

    return devices.every((device) => device.status === 'offline') ? 'full' : 'partial';
  }

  toggleMultiViewDevice(device: IDevice): void {
    const isSelected = this.isMultiViewDeviceSelected(device);

    if (isSelected) {
      this.selectedDeviceLabels = this.selectedDeviceLabels.filter((label) => label !== device.label);
    } else if (!this.isMultiViewDeviceSelectable(device)) {
      return;
    } else if (this.selectedDeviceLabels.length < this.maxMultiViewDevices) {
      this.selectedDeviceLabels = [...this.selectedDeviceLabels, device.label];
    }

    this.syncSelectedStreamingDevices();
  }

  isMultiViewDeviceSelected(device: IDevice): boolean {
    return this.selectedDeviceLabels.includes(device.label);
  }

  isMultiViewDeviceSelectable(device: IDevice): boolean {
    return device.status !== 'offline' && device.status !== 'disabled';
  }

  isMultiViewDeviceDisabled(device: IDevice): boolean {
    return !this.isMultiViewDeviceSelected(device)
      && (!this.isMultiViewDeviceSelectable(device) || this.selectedDeviceLabels.length >= this.maxMultiViewDevices);
  }

  getDeviceRoomLabel(device: IDevice): string {
    return device.facilities?.room?.name || 'Stanza non assegnata';
  }

  getDeviceStatusLabel(device: IDevice): string {
    switch (device.status) {
      case 'online':
        return 'Online';
      case 'warning':
        return 'Attenzione';
      case 'disabled':
        return 'Disabilitata';
      case 'offline':
      default:
        return 'Offline';
    }
  }

  trackDeviceByLabel(index: number, device: IDevice): string {
    return device.label || String(index);
  }

  private refreshMultiViewDevices(): void {
    const devicesByLabel = new Map<string, IDevice>();

    this.unitsTree.forEach((unit) => {
      unit.rooms?.forEach((room) => {
        room.devices?.forEach((device) => {
          if (!device.label || devicesByLabel.has(device.label)) {
            return;
          }

          devicesByLabel.set(device.label, {
            ...device,
            facilities: {
              ...(device.facilities || {}),
              unit: device.facilities?.unit || (unit.id ? { id: unit.id, name: unit.name } : undefined),
              room: device.facilities?.room || (room.id ? { id: room.id, name: room.name } : undefined)
            }
          });
        });
      });
    });

    this.availableStreamingDevices = Array.from(devicesByLabel.values()).sort((a, b) =>
      this.getDeviceSortLabel(a).localeCompare(this.getDeviceSortLabel(b), 'it', { sensitivity: 'base' })
    );

    const availableLabels = new Set(this.availableStreamingDevices.map((device) => device.label));
    this.selectedDeviceLabels = this.selectedDeviceLabels
      .filter((label) => availableLabels.has(label))
      .slice(0, this.maxMultiViewDevices);
    this.syncSelectedStreamingDevices();
  }

  private syncSelectedStreamingDevices(): void {
    this.selectedStreamingDevices = this.selectedDeviceLabels
      .map((label) => this.availableStreamingDevices.find((device) => device.label === label))
      .filter((device): device is IDevice => !!device);
  }

  private getDeviceSortLabel(device: IDevice): string {
    return `${device.facilities?.unit?.name || ''} ${device.facilities?.room?.name || ''} ${device.label}`;
  }

  refreshSilencedSensor() {
    this.loggerService.info("Refresh dati temporizzazione")
    const roomsById = new Map<string, IRoom[]>();

    [...this.unitsTree, ...this.spatialUnits].forEach((unit) => {
      unit.rooms?.forEach((room) => {
        if (!room.id || !room.devices?.length) return;
        roomsById.set(room.id, [...(roomsById.get(room.id) || []), room]);
      });
    });

    roomsById.forEach((rooms, roomId) => {
      this.sensorService.isSensorSilenced$(roomId).pipe(
        take(1),
        tap((data) => {
          rooms.forEach((room) => {
            room.notificationSilencedList = data;
            room.bedExitDelayMinutes = data.bedExitDelayMinutes;
          });
        })
      ).subscribe();
    });
  }

  getUnitAlerts(unit: IUnit) {
    return unit.rooms?.reduce((acc, curr) => {
      if (curr.alert && !acc.some((item) => item.severity === curr.alert?.severity)) {
        curr.alert.severity !== 'low' && acc.push({
          icon: eventTypeToData[curr.alert.eventType].statusIcon,
          color: eventTypeToData[curr.alert.eventType].exaColor,
          severity: curr.alert.severity
        })
      }
      return acc;
    }, [] as { icon: string; color: string; severity: 'medium' | 'high' }[])
  }

  public get currentMentorageTutorialStep(): MentorageTutorialStep {
    const steps = this.isDesktop ? this.desktopMentorageTutorialSteps : this.mobileMentorageTutorialSteps;
    return steps[this.mentorageTutorialStepIndex];
  }

  nextMentorageTutorialStep(): void {
    // Opening, managing and closing advance only through the actual controls in the example.
    if ([6, 8, 9].includes(this.mentorageTutorialStepIndex)) return;
    if (this.mentorageTutorialProgressIndex >= this.mentorageTutorialSteps.length - 1) {
      this.finishMentorageTutorial();
      return;
    }

    this.setMentorageTutorialStep(this.tutorialStepOrder[this.mentorageTutorialProgressIndex + 1]);
  }

  previousMentorageTutorialStep(): void {
    if (this.mentorageTutorialStepIndex === 10) {
      void this.openTutorialAlert(9);
      return;
    }
    if (this.mentorageTutorialProgressIndex === 0) {
      if (this.mentorageGuideNavigationOffset) void this.guide.returnToMentorageNavigation();
      return;
    }

    this.setMentorageTutorialStep(this.tutorialStepOrder[this.mentorageTutorialProgressIndex - 1]);
  }

  skipMentorageTutorial(): void {
    void this.guide.cancel();
  }

  openTutorialExampleRoom(): void {
    if (!this.mentorageTutorialActive || this.mentorageTutorialStepIndex !== 2) {
      return;
    }

    this.dialog.open(this.tutorialExampleDialog, {
      width: '95vw',
      maxWidth: '430px',
      maxHeight: '90vh',
      panelClass: 'soft-modal-panel',
      autoFocus: false
    });
  }

  async openTutorialAlert(firstStep: 7 | 9 = 7): Promise<void> {
    const origin = this.mentorageTutorialStepIndex;
    if (!this.mentorageTutorialActive || (firstStep === 7 ? origin !== 6 : origin !== 10)
      || this.tutorialAlertOpening || this.tutorialAlertOverlayRef) return;
    this.tutorialAlertOpening = true;
    try {
      const { TutorialAlertDialogComponent } = await import('../../../../shared/components/tutorial-alert-dialog/tutorial-alert-dialog.component');
      if (!this.mentorageTutorialActive || this.mentorageTutorialStepIndex !== origin) return;
      // A body-level overlay avoids Ionic clipping. The modal and tutorial are separate siblings
      // with a shared keyboard focus scope; the tutorial never becomes part of the room content.
      const ref = this.overlay.create({
        width: '100%', height: '100%', hasBackdrop: true,
        positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
        scrollStrategy: this.overlay.scrollStrategies.block()
      });
      this.tutorialAlertOverlayRef = ref;
      this.tutorialAlertComponentRef = ref.attach(new ComponentPortal(TutorialAlertDialogComponent));
      this.tutorialAlertComponentRef.instance.action$.pipe(takeUntil(this.destroy$), takeUntil(ref.detachments()))
        .subscribe(action => this.onTutorialAlertAction(action));
      ref.keydownEvents().pipe(takeUntil(this.destroy$), takeUntil(ref.detachments())).subscribe(event => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        event.stopPropagation();
        this.onTutorialAlertAction('close');
      });
      this.setMentorageTutorialStep(firstStep);
    } catch {
      this.disposeTutorialAlert();
      if (this.mentorageTutorialActive) {
        void this.guide.unavailable();
      }
    } finally {
      this.tutorialAlertOpening = false;
    }
  }

  private onTutorialAlertAction(action: TutorialAlertAction): void {
    if (!this.mentorageTutorialActive || !this.tutorialAlertOverlayRef) return;
    const step = this.mentorageTutorialStepIndex;
    if (action === 'skip') { this.skipMentorageTutorial(); return; }
    if (action === 'next' && step === 7) { this.setMentorageTutorialStep(8); return; }
    if (action === 'manage' && step === 8) { this.setMentorageTutorialStep(9); return; }
    if (action === 'back' && step > 7) { this.setMentorageTutorialStep(step - 1); return; }
    if (action === 'close' || (action === 'back' && step === 7)) {
      const target = action === 'close' && step === 9 ? 10 : 6;
      this.disposeTutorialAlert();
      this.setMentorageTutorialStep(target);
      this.cdRef.detectChanges();
      if (target === 6) this.tutorialFallAlertElement?.nativeElement.focus();
      else this.mentorageTutorialCardElement?.nativeElement.focus();
    }
  }

  private disposeTutorialAlert(): void {
    const ref = this.tutorialAlertOverlayRef;
    this.tutorialAlertOverlayRef = undefined;
    this.tutorialAlertComponentRef = undefined;
    ref?.dispose();
  }

  getMentorageTutorialTranslationKey(field: 'TITLE' | 'DESCRIPTION'): string {
    if (this.currentMentorageTutorialStep === 'ROOM' && field === 'DESCRIPTION') {
      return `GUIDE.MODULES.ROOMS.${this.isDesktop ? 'DESKTOP' : 'MOBILE'}_2`;
    }
    if (this.isDesktop && this.currentMentorageTutorialStep === 'OVERVIEW') {
      return `DESKTOP_TUTORIAL.MENTORAGE.OVERVIEW.${field}`;
    }
    if (this.showSpatialMap
      && this.currentMentorageTutorialStep === 'STRUCTURE' && field === 'DESCRIPTION') {
      return 'DESKTOP_TUTORIAL.MENTORAGE.SPATIAL_DESCRIPTION';
    }
    return `MENTORAGE_TUTORIAL.STEPS.${this.currentMentorageTutorialStep}.${field}`;
  }

  private startMentorageTutorial(): void {
    if (!this.mentorageGuideNavigationOffset || this.mentorageTutorialActive) {
      return;
    }

    this.mentorageTutorialActive = true;
    this.tutorialAlertManaged = false;
    this.setMentorageTutorialStep(this.guideStepOrder?.[0] ?? 0);
  }

  private setMentorageTutorialStep(stepIndex: number): void {
    this.mentorageTutorialStepIndex = stepIndex;
    if (stepIndex >= 7 && stepIndex <= 9 && this.tutorialAlertComponentRef) {
      this.tutorialAlertManaged = stepIndex === 9;
      this.mentorageTutorialSpotlight = undefined;
      const component = this.tutorialAlertComponentRef;
      component.instance.stage = stepIndex === 7 ? 'stream' : stepIndex === 8 ? 'manage' : 'close';
      component.instance.current = this.mentorageTutorialProgressIndex + 1 + this.mentorageGuideNavigationOffset;
      component.instance.total = this.mentorageTutorialSteps.length + this.mentorageGuideNavigationOffset;
      component.changeDetectorRef.detectChanges();
      component.instance.focusInstruction();
      return;
    }
    this.currentSegment = this.isDesktop && stepIndex === 5
      ? 'multi'
      : stepIndex >= 3 ? 'allerts' : 'structure';

    if (stepIndex === 2) {
      this.cdRef.detectChanges();
      this.scrollTutorialRoomIntoView();
    } else if (stepIndex === 6) {
      this.tutorialAlertManaged = false;
      this.cdRef.detectChanges();
      setTimeout(() => {
        this.tutorialFallAlertElement?.nativeElement.scrollIntoView({ block: 'center', behavior: 'smooth' });
        this.scheduleMentorageSpotlightUpdate(350);
      });
    } else {
      this.scheduleMentorageSpotlightUpdate();
    }
  }

  private scrollTutorialRoomIntoView(): void {
    setTimeout(() => {
      const target = this.tutorialExampleRoomElement?.nativeElement;
      target?.scrollIntoView({
        block: 'center',
        behavior: 'smooth'
      });
      this.scheduleMentorageSpotlightUpdate(400);
    }, 0);
  }

  private scheduleMentorageSpotlightUpdate(delay: number = 80): void {
    if (this.mentorageSpotlightUpdateTimeoutId) {
      clearTimeout(this.mentorageSpotlightUpdateTimeoutId);
    }

    this.mentorageTutorialSpotlight = undefined;
    if (this.isDesktop) {
      this.mentorageTutorialCardPosition = undefined;
    }
    this.mentorageSpotlightUpdateTimeoutId = setTimeout(() => {
      this.updateMentorageSpotlight();
    }, delay);
  }

  private updateMentorageSpotlight(): void {
    if (this.tutorialAlertOverlayOpen) return;
    const target = this.getMentorageSpotlightTarget();
    if (!target) {
      this.mentorageTutorialSpotlight = undefined;
      this.mentorageTutorialCardPosition = undefined;
      return;
    }

    const rect = target.getBoundingClientRect();
    const isSegmentTarget = [0, 1, 3, 5].includes(this.mentorageTutorialStepIndex);
    const verticalPadding = this.mentorageTutorialStepIndex === 2 ? 7 : 5;
    // Constrain segment width while preserving the original vertical padding.
    const horizontalPadding = isSegmentTarget ? -5 : verticalPadding;
    const left = Math.max(5, rect.left - horizontalPadding);
    const top = Math.max(5, rect.top - verticalPadding);
    const right = Math.min(window.innerWidth - 5, rect.right + horizontalPadding);
    const bottom = Math.min(window.innerHeight - 5, rect.bottom + verticalPadding);

    this.mentorageTutorialSpotlight = {
      top,
      left,
      width: Math.max(0, right - left),
      height: Math.max(0, bottom - top),
      borderRadius: [2, 6, 10].includes(this.mentorageTutorialStepIndex) ? 20 : 30
    };
    if (this.isDesktop) {
      const card = this.mentorageTutorialCardElement?.nativeElement;
      // Ionic clips overlays to the content area; the sidebar is outside these bounds.
      const contentRect = card?.closest('ion-content')?.getBoundingClientRect();
      const viewportLeft = Math.max(0, contentRect?.left ?? 0);
      const viewportTop = Math.max(0, contentRect?.top ?? 0);
      this.mentorageTutorialCardPosition = card
        ? positionTutorialCard(rect, card.getBoundingClientRect(), {
          left: viewportLeft,
          top: viewportTop,
          width: Math.min(window.innerWidth, contentRect?.right ?? window.innerWidth) - viewportLeft,
          height: Math.min(window.innerHeight, contentRect?.bottom ?? window.innerHeight) - viewportTop
        }, 20)
        : undefined;
    }
  }

  private getMentorageSpotlightTarget(): HTMLElement | undefined {
    switch (this.mentorageTutorialStepIndex) {
      case 0:
        return this.tutorialSegmentElement?.nativeElement;
      case 1:
        return this.tutorialStructureElement?.nativeElement;
      case 2:
        return this.tutorialExampleRoomElement?.nativeElement;
      case 3:
        return this.tutorialAlertsElement?.nativeElement;
      case 4:
        if (this.showTutorialAlertList) return this.tutorialAlertsElement?.nativeElement;
        return this.isDesktop
          ? this.tutorialAlertCardElements?.first?.nativeElement || this.tutorialAlertsElement?.nativeElement
          : undefined;
      case 5:
        return this.isDesktop ? this.tutorialMultiElement?.nativeElement : undefined;
      case 6:
      case 10:
        return this.tutorialFallAlertElement?.nativeElement;
      default:
        return undefined;
    }
  }

  private finishMentorageTutorial(): void {
    this.mentorageTutorialActive = false;
    this.disposeTutorialAlert();
    this.mentorageTutorialStepIndex = 0;
    this.mentorageTutorialSpotlight = undefined;
    this.mentorageTutorialCardPosition = undefined;
    if (this.mentorageSpotlightUpdateTimeoutId) {
      clearTimeout(this.mentorageSpotlightUpdateTimeoutId);
    }
    this.guideStepOrder = undefined;
    void this.guide.completeModule();
  }

  openModal(room: IRoom) {
    this.reorderDevicesOnModal(room.devices || [], room.alert);
    this.dialog.open(RoomDetailsDialogComponent, {
      data: {
        title: `${room.name}`,
        roomId: room.id,
        beds: room.beds,
        devices: room.devices,
        tutorialMode: this.mentorageTutorialActive && this.mentorageTutorialStepIndex === 2,
        alertService: this.alertService,
        sensorService: this.sensorService
      },
      width: this.isDesktop ? '55vw' : '95vw',
      maxWidth: '95vw',
      maxHeight: '90vh',
      panelClass: 'soft-modal-panel',
      autoFocus: false
    });
  }

  openModalFromAlert(alert: INotificationData) {
    let beds: IBed[] = [];
    let devices: IDevice[] = [];
    this.unitsTree.forEach((unit) => {
      (alert?.facilities.unit.id === unit.id) && unit.rooms?.forEach((room) => {
        if ((alert?.facilities.room.id === room.id) && room.devices?.some((device) => device.label === alert?.deviceId)) {
          beds = room.beds || [];
          devices = room.devices?.filter((device) => device.label === alert?.deviceId);
        }
      })
    });
    this.reorderDevicesOnModal(devices, alert);
    this.dialog.open(RoomDetailsDialogComponent, {
      data: {
        title: `${alert.facilities.room.name}`,
        roomId: alert.facilities.room.id,
        beds,
        devices,
        alert,
        alertService: this.alertService,
        sensorService: this.sensorService
      },
      width: this.isDesktop ? '65vw' : '95vw',
      maxWidth: '95vw',
      maxHeight: '90vh'
    });
    //this.onModalClosed(dialogRef);
  }

  reorderDevicesOnModal(devices: IDevice[], alert?: INotificationData) {
    if (alert) {
      devices = devices.sort((a, b) => {
        if (a.label === alert.deviceId) {
          return -1; // a viene prima
        } else if (b.label === alert.deviceId) {
          return 1; // b viene prima
        } else {
          return 0; // Nessun cambiamento di ordine
        }
      });
    } else if (devices.some((device) => device.status === "offline") && devices.some((device) => device.status === "online")) {
      devices = devices.sort((a, b) => {
        if (a.status === 'online') {
          return -1; // a viene prima
        } else if (b.status === 'online') {
          return 1; // b viene prima
        } else {
          return 0; // Nessun cambiamento di ordine
        }
      });
    }
  }

  async manageAll() {
    const alert = await this.alertController.create({
      header: 'ATTENZIONE',
      message: 'Gestire tutte le allerte?',
      cssClass: 'soft-alert-dialog',
      buttons: [{
        text: 'Chiudi',
        role: 'close',
        cssClass: 'alert-btn-neutral',
        handler: () => { },
      },
      {
        text: 'Gestisci tutte',
        role: 'manage',
        cssClass: 'alert-btn-primary',
        handler: () => {
          this.manageAllRunning = true;
          this.ringtoneService.stopRingtone();
          from(this.alertsList).pipe(
            concatMap((alertEl) =>
              this.alertService.manageAlert$(alertEl.id).pipe(
                tap(() => {
                  this.sharedSrv.removeLocallyManagedAlert(alertEl);
                }),
                catchError((err) => {
                  (err.error.error === "15") && this.sharedSrv.removeLocallyManagedAlert(alertEl);
                  return of(null);
                })
              )
            ),
            finalize(() => {
              this.manageAllRunning = false;
            })
          ).subscribe();
        },
      }],
    });
    await alert.present();
  }

  ngAfterViewInit(): void {
    const processElements = (list: QueryList<ElementRef>) => {
      if (this.unitsTree.reduce((acc, curr) => { acc += curr.rooms?.length || 0; return acc }, 0) === list.length) {
        this.unitsTree.forEach((unit) => {
          unit.rooms?.forEach((room) => {
            const roomTextElement = list.find((element) => element.nativeElement.textContent.trim() === room.name.trim());
            if (roomTextElement) {
              room.isTextTooLong = roomTextElement.nativeElement.scrollWidth > roomTextElement.nativeElement.clientWidth
            }
          })
        })
      }
      this.cdRef.detectChanges();
    };
    this.textElements.changes.pipe(
      takeUntil(this.destroy$)
    ).subscribe((list: QueryList<ElementRef>) => {
      processElements(list);
    });
  }

  ngOnDestroy(): void {
    this.disposeTutorialAlert();
    if (this.mentorageTutorialActive && this.guide.running()) void this.guide.unavailable();
    this.destroy$.next();
    this.destroy$.complete();
    this.silencedRefreshTimeoutId && clearTimeout(this.silencedRefreshTimeoutId);
    this.silencedRefreshIntervalId && clearInterval(this.silencedRefreshIntervalId);
    this.mentorageSpotlightUpdateTimeoutId && clearTimeout(this.mentorageSpotlightUpdateTimeoutId);
    if (this.mentorageScrollFrame !== undefined) {
      cancelAnimationFrame(this.mentorageScrollFrame);
    }
    document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
    document.removeEventListener('scroll', this.mentorageScrollHandler, true);
  }

  scheduleFunctionAtSpecificMinutes(): void {
    if (this.silencedRefreshScheduled) {
      return;
    }

    this.silencedRefreshScheduled = true;

    // Esegui la funzione immediatamente all'avvio se l'ora lo permette
    const now = new Date();
    const currentMinute = now.getMinutes();

    if (currentMinute === 1 || currentMinute === 31) {
      this.refreshSilencedSensor();
    }

    // Calcola il tempo rimanente fino alla prossima esecuzione
    let nextExecutionMinute;
    if (currentMinute < 1) {
      nextExecutionMinute = 1;
    } else if (currentMinute < 31) {
      nextExecutionMinute = 31;
    } else {
      // Se è dopo il :31, la prossima sarà all'ora successiva al :01
      nextExecutionMinute = 1;
      now.setHours(now.getHours() + 1); // Passa all'ora successiva
    }

    now.setMinutes(nextExecutionMinute);
    now.setSeconds(0);
    now.setMilliseconds(0);

    const delayUntilNextExecution = now.getTime() - new Date().getTime();

    this.loggerService.info(`Prossimo refresh dati temporizzazione: ${now.toLocaleTimeString()}`);

    this.silencedRefreshTimeoutId = setTimeout(() => {
      this.refreshSilencedSensor(); // Esegui la funzione la prima volta
      // Poi imposta un intervallo per le esecuzioni successive ogni 30 minuti
      this.silencedRefreshIntervalId = setInterval(() => {
        this.refreshSilencedSensor();
      }, 30 * 60 * 1000); // 30 minuti in millisecondi
    }, delayUntilNextExecution);
  }

}
